import script from "./OnboardingTooltips.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingTooltips.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingTooltips.vue?vue&type=style&index=0&id=2907a77e&lang=scss"

const __exports__ = script;

export default __exports__